import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Typography, styled } from '@material-ui/core';
import AllRowSelectorFormatter from './formatters/AllRowSelectorFormatter';

const StyledTypography = styled(Typography)(({ theme }) => ({
  fontStyle: 'italic',
  color: theme.palette.text.secondary
}));

export const buildColumns = ({
  classes,
  editable,
  availableToBillStates,
  visibleColumns = []
}) => ({
  rowSelector: {
    field: 'rowSelector',
    visible: editable,
    hideInSettingsDialog: true,
    className: classes.rowSelector,
    availableToBillStates,
    value: (
      <AllRowSelectorFormatter availableToBillStates={availableToBillStates} />
    )
  },
  client: {
    field: 'client',
    visible: visibleColumns.includes('client'),
    required: true,
    isDefault: true,
    value: <FormattedMessage id="avaialbleToBillList.client" />,
    className: classes.dynamicColumn
  },
  project: {
    field: 'project',
    visible: visibleColumns.includes('project'),
    required: true,
    isDefault: true,
    value: <FormattedMessage id="avaialbleToBillList.project" />,
    className: classes.dynamicColumn,
    customNoValue: (
      <StyledTypography variant="body2">
        <FormattedMessage id="avaialbleToBillList.multipleProjects" />
      </StyledTypography>
    )
  },
  projectLeader: {
    field: 'projectLeader',
    visible: visibleColumns.includes('projectLeader'),
    required: false,
    isDefault: true,
    value: <FormattedMessage id="avaialbleToBillList.projectLeader" />,
    className: classes.projectManager
  },
  date: {
    field: 'date',
    visible: visibleColumns.includes('date'),
    required: true,
    isDefault: true,
    value: <FormattedMessage id="avaialbleToBillList.date" />
  },
  amount: {
    field: 'amount',
    visible: visibleColumns.includes('amount'),
    required: true,
    isDefault: true,
    value: <FormattedMessage id="avaialbleToBillList.amount" />,
    align: 'right',
    className: classes.amount
  },
  createBill: {
    field: 'createBill',
    visible: editable,
    hideInSettingsDialog: true,
    value: '',
    className: classes.createBill
  }
});
